import { Link } from "react-router-dom";
import {
  Decision,
  Home,
  Page404,
  Test,
  Feed,
  Lesson,
  Enroll,
  Qpay,
  Payment,
  SeatConfirm,
  StudentPayment,
  StudentQpay,
  Contract,
  PaymentStatus,
  CollegePrepForm,
  CollegePrepReport,
  CollegePrepParent,
} from "pages";
import Layout from "layout";
import Timetable from "pages/Timetable";
import ScheduleAttendance from "pages/ScheduleAttendance";
import Assignment from "pages/Assignment";
import ChooseMeeting from "pages/MeetingHour";
import RoomBooking from "pages/RoomBooking";
import Learning from "pages/Learning";
import LearningSeries from "pages/Learning/Series";
import LearningPlayer from "pages/Learning/Player";
import ChildPage from "pages/Home/ChildPage";
import ElemProjectPage from "pages/Elem/ProjectPage";
import ElemSchoolPage from "pages/Elem/SchoolPage";
import TodoPage from "pages/Todo";
import ConsentPage from "pages/Consent";
import SurveyPage from "pages/Survey";
import Exams from "pages/Exams";
import ExamTake from "pages/Exams/Take";
import Reflections from "pages/Reflections";
import Study from "pages/Study";
import Growth from "pages/Growth";
import Passion from "pages/Passion";
import StudyCourse from "pages/Study/Course";
import StudyReport from "pages/Study/Report";
import StudyPbl from "pages/Study/Pbl";
import { Navigate } from "react-router-dom";
import Counseling from "pages/Counseling";
import CounselingBook from "pages/Counseling/Book";
import CounselingSession from "pages/Counseling/Session";
import House from "pages/House";

const routes = [
  {
    path: "/",
    errorElement: <div>error</div>,
    element: <Layout />,
    children: [
      {
        name: "Home",
        index: true,
        element: <Home />,
      },
      {
        name: "Student qpay",
        path: "/student/qpay/:guid",
        element: <StudentQpay />,
      },
      {
        name: "Not Found",
        path: "/*",
        element: <Page404 />,
      },
      {
        // Эцэг эх: хүүхдийн мэдээлэл (хаус, ирц) — нүүр зөвхөн эцэг эхийнх
        name: "Child",
        path: "/child",
        element: <ChildPage />,
      },
      {
        // Бага анги: төслийн дэлгэрэнгүй (?c=хүүхэд)
        name: "ElemProject",
        path: "/child/project/:id",
        element: <ElemProjectPage />,
      },
      {
        // Бага анги: Сургууль — чөлөө, өдөр өнжүүлэх, санал хүсэлт, календарь
        name: "School",
        path: "/school",
        element: <ElemSchoolPage />,
      },
      {
        // Хийх зүйл: унших / зөвшөөрөл / захидал — эцэг эх баталгаажуулна
        name: "Todo",
        path: "/todo/:id",
        element: <TodoPage />,
      },
      {
        // Зөвшөөрлийн хуудас — эцэг эх хүүхэд бүрээр зөвшөөрнө
        name: "Consent",
        path: "/consent/:id",
        element: <ConsentPage />,
      },
      {
        // Сэтгэл ханамжийн асуулга — асуулт бүрээр бөглөнө (эцэг эх хүүхэд бүрээр, сурагч өөрөө)
        name: "Survey",
        path: "/survey/:id",
        element: <SurveyPage />,
      },
      {
        name: "Feed",
        path: "/feed",
        element: <Feed />,
      },
      {
        name: "Assignment",
        path: "/assignment",
        element: <Assignment />,
      },
      {
        // Хичээлийн хуваарь (сурагч өөрийнхөө, эцэг эх хүүхдүүдийнхээ)
        name: "Timetable",
        path: "/schedule",
        element: <Timetable />,
      },
      {
        // Онлайн тест (сурагч): жагсаалт, тест өгөх / үр дүн
        name: "Exams",
        path: "/exams",
        element: <Exams />,
      },
      {
        name: "ExamTake",
        path: "/exams/:id",
        element: <ExamTake />,
      },
      {
        // Сурлага (сурагч): голч, хичээл бүрийн СҮД, даалгавар, зөвлөмж, улирлын тайлан. Эцэг эх "Хүүхэд" хуудсаар.
        name: "Study",
        path: "/study",
        element: <Study />,
      },
      { name: "StudyCourse", path: "/study/c/:courseId", element: <StudyCourse /> },
      { name: "StudyPbl", path: "/study/pbl/:id", element: <StudyPbl /> },
      // Хөгжил (сурагч): Passion Program, хаус, зөвлөгөө, их сургууль
      { name: "Growth", path: "/growth", element: <Growth /> },
      // Passion Program сонголт (сурагч; эцэг эх ?s=<хүүхэд>) — мэдэгдлээс энд үсэрнэ
      { name: "Passion", path: "/passion", element: <Passion /> },
      { name: "StudyReport", path: "/study/report", element: <StudyReport /> },
      // Хуучин "Дүн" холбоос
      { name: "Grades", path: "/grades", element: <Navigate to="/study" replace /> },
      {
        // Хичээлийн дараах тусгал (сурагч) — ирцэд тооцогдоно
        name: "Reflections",
        path: "/reflections",
        element: <Reflections />,
      },
      {
        // Зөвлөгөө (сурагч): миний уулзалтууд, цаг захиалах, уулзалтын дэлгэрэнгүй (мэдэгдэл /counseling/:id руу холбоно)
        name: "Counseling",
        path: "/counseling",
        element: <Counseling />,
      },
      {
        name: "CounselingBook",
        path: "/counseling/book",
        element: <CounselingBook />,
      },
      {
        name: "CounselingSession",
        path: "/counseling/:id",
        element: <CounselingSession />,
      },
      {
        // Хаусын ерөнхийлөгч (сурагч): хаусынхаа өдрийн ирц
        name: "House",
        path: "/house",
        element: <House />,
      },
      {
        name: "schedule_attendance",
        path: "/schedule_attendance",
        element: <ScheduleAttendance />,
      },
      {
        name: "Seat Confrim",
        path: "/seatconfirm",
        element: <SeatConfirm />,
      },
      {
        name: "RoomBooking",
        path: "/booking",
        element: <RoomBooking />,
      },
      {
        name: "Meetchoose",
        path: "/meeting-hour",
        element: <ChooseMeeting />,
        // handle: {
        //   crumb: () => <Link to={"/meeting-hour"}>Home</Link>,
        // },
      },
      {
        name: "Payment Status",
        path: "/paymentstatus",
        element: <PaymentStatus />,
      },
      {
        name: "Payment",
        path: "/payment",
        element: <Payment />,
      },
      {
        name: "StudentPayment",
        path: "/student/payment/:id",
        element: <StudentPayment />,
      },
      {
        name: "StudentPayment",
        path: "/student/payment/:id/:guid",
        element: <StudentPayment />,
      },
      { name: "Qpay", path: "payment/qpay/:guid", element: <Qpay /> },
      {
        name: "CollegePrep",
        path: "/college-prep",
        element: <CollegePrepForm />,
      },
      {
        name: "CollegePrepParent",
        path: "/college-prep/children",
        element: <CollegePrepParent />,
      },
      {
        name: "CollegePrepReport",
        path: "/college-prep/report",
        element: <CollegePrepReport />,
      },
      {
        // Сургалт (эцэг эх): цувралын жагсаалт, цуврал, үзэх
        name: "Learning",
        path: "/learning",
        element: <Learning />,
      },
      {
        name: "LearningSeries",
        path: "/learning/:id",
        element: <LearningSeries />,
      },
      {
        name: "LearningPlayer",
        path: "/learning/item/:itemId",
        element: <LearningPlayer />,
      },
      {
        name: "Contract",
        path: "/contract/:id",
        element: <Contract />,
      },
      {
        name: "Contract",
        path: "/contract/:id/:guid",
        element: <Contract />,
      },
    ],
  },

  // pages without main layout
  {
    name: "decision",
    path: "/decision",
    element: <Decision />,
    handle: {
      crumb: () => <Link to={"/decision"}>Home</Link>,
    },
  },

  // it will render when there are no pages on the website
  {
    name: "Not Found",
    path: "/*",
    element: <Page404 />,
  },
];

export default routes;
